const maintenanceMessages = {
  post: 'Mantenimiento agregado con éxito',
  update: 'Mantenimiento actualizado con éxito',
  delete: 'Mantenimiento eliminado con éxito',
};

export default maintenanceMessages;